import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ isAuthenticated, children }) => {
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to={{ pathname: "/login", search: location.search }} replace />;
  }
  return children;
};

export default ProtectedRoute;
